import { Routes, Route } from '@angular/router';
import { ShellComponent } from './shell.component';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShellService {
  private isLoadingSubject = new Subject<boolean>();

  public readonly isLoading$: Observable<boolean> =
    this.isLoadingSubject.asObservable();

  setIsLoading(isLoading: boolean): void {
    this.isLoadingSubject.next(isLoading);
  }

  static childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: ShellComponent,
      children: routes,
    };
  }
}
